import React from "react";
import PropTypes from "prop-types";

import Section from "../common/Section";
import Form from "../common/Form";
import Fieldset from "../common/Fieldset";
import DownloadUploadFile from "../common/DownloadUploadFiles";
import Row from "../common/Row";
import RadioButtonGroup from "../common/RadioButtonGroup";
import PlusMinButtons from "../common/PlusMinButtons";
import TextAreaInput from "../common/TextAreaInput";
import SelectInput from "../common/SelectInput";
import NumberInput from "../common/NumberInput";
import * as domainConstants from "../../constants/DomainConstants";
import moment from "moment";
import { orderByPropertyName } from "../../util/orderBy";

const MinimaleEisenPerDossierForm = (props) => {
	const {
		minimaleEisenPerDossier,
		documenten,
		sjablonen,
		fileTypes,
		disabled,
		errors,
		onChange,
		onDropFiles,
		onDeleteFile,
		onSave,
		onTopsportfederatieAdd,
		color,
		fileSessionStarted,
		validationMessageType
	} = props;

	const jaNee = [
		{ value: "true", label: 'Ja' },
		{ value: "false", label: 'Nee' }
	];

	const TITEL_TOOLTIP = "Hier vind je de minimale eisen terug gemeenschappelijk voor alle opgegeven sportinfrastructuren. Links kan je de opgegeven sportinfrastructuren aanklikken en telkens afzonderlijk de minimale eisen invullen die specifiek per type sportinfrastructuur gelden";
	const WELKEWERKENGESTART_TOOLTIP = "Overeenkomstig de Europese staatssteunregels mogen de werken waarvoor een subsidie wordt aangevraagd nog niet gestart zijn. Dat geldt niet voor het ontwerpen van de nieuwbouw of renovatie van de sportinfrastructuur en voor het bouwrijp maken van het terrein.";
	const OPENGESTELDBREEDPUBLIEK_TOOLTIP = "Hiermee wordt bedoeld dat één partij niet beschikt over het exclusief gebruik van de sportinfrastructuur.";
	const MARKTCONFORM_TOOLTIP = "De subsidieaanvrager garandeert redelijke en rechtvaardige tarieven (toegangsprijzen/ lidgelden/ verhuurprijzen) voor alle sportinfrastructuren waarvoor er subsidies worden aangevraagd. Tarieven kunnen vergeleken worden met prijzen in de (Vlaamse) markt en in de directe omgeving van de sportinfrastructuur. Indien dit niet mogelijk is, wordt er een (inter)nationale benchmark voorgesteld. ";

	function mapDropFiles(component) {
		return function (files) {
			onDropFiles(component, files);
		};
	}

	function mapDeleteFile(component) {
		return function (fileName) {
			onDeleteFile(component, fileName);
		};
	}

	function getFilesForDossierComponent(component) {
		if (documenten) {
			const folder = documenten.find(x => x.name === component);
			if (folder) return folder.files;
		}
		return [];
	}

	function hasFilesForDossierComponent(component) {
		if (documenten) {
			const folder = documenten.find(x => x.name === component);
			if (folder) {
				if (folder.files) {
					return folder.files.length > 0 ? true : false;
				}
			}
		}
		return false;
	}

	function onTopsportfederatieChange(i) {
		return (event) => {
			props.onTopsportfederatieChange(event, i);
		};
	}
	function onTopsportfederatieRemove(i) {
		return () => {
			props.onTopsportfederatieRemove(i);
		};
	}
	function getFilesForSjabloonComponent(component) {
		if (sjablonen) {
			const folder = sjablonen.find(x => x.name === component);
			if (folder) return folder.files;
		}
		return [];
	}

	if (minimaleEisenPerDossier.selectedTopsportFederaties == null) {
		minimaleEisenPerDossier.selectedTopsportFederaties = [];
	}

	let selectedTopSportFederaties = null;
	if (minimaleEisenPerDossier.prioritairVoorVlaamseTopsportfederaties == true || minimaleEisenPerDossier.prioritairVoorVlaamseTopsportfederaties === "true") {
		selectedTopSportFederaties = orderByPropertyName(minimaleEisenPerDossier.prioritairGebruikTopsportfederaties, "topsportfederatie").map((item, i) => {
			const federatiesToShow = minimaleEisenPerDossier.topsportFederaties.filter(x => minimaleEisenPerDossier.prioritairGebruikTopsportfederaties.map((p) => p.topsportfederatie).indexOf(x) === -1 || item.topsportfederatie === x);

			let prioritairErrors = null;
			if (errors != null) {
				prioritairErrors = errors.prioritairGebruikTopsportfederaties != undefined ? errors.prioritairGebruikTopsportfederaties[i] : null;
			}

			return (
				<Row key={"topsport" + i}>
					<SelectInput
						value={item.topsportfederatie}
						name="topsportfederatie"
						label="Topsportfederatie"
						items={federatiesToShow}
						onChange={onTopsportfederatieChange(i)}
						disabled={disabled}
						validationMessage={prioritairErrors ? prioritairErrors.topsportfederatie : ''}
						validationMessageType={validationMessageType}
						size={4} />
					<NumberInput
						value={item.aantalUrenPerWeekVoorPrestatieprogramma}
						name="aantalUrenPerWeekVoorPrestatieprogramma"
						label="Uren/Week voor Prestatieprogramma"
						onChange={onTopsportfederatieChange(i)}
						disabled={disabled}
						validationMessage={prioritairErrors ? prioritairErrors.aantalUrenPerWeekVoorPrestatieprogramma : ''}
						validationMessageType={validationMessageType}
						size={3} />
					<NumberInput
						value={item.aantalUrenPerWeekVoorOntwikkelingsrogramma}
						name="aantalUrenPerWeekVoorOntwikkelingsrogramma"
						label="Uren/Week voor Ontwikkelingsprogramma"
						onChange={onTopsportfederatieChange(i)}
						disabled={disabled}
						validationMessage={prioritairErrors ? prioritairErrors.aantalUrenPerWeekVoorOntwikkelingsrogramma : ''}
						validationMessageType={validationMessageType}
						size={3} />
					<PlusMinButtons
						minButtonEnabled={minimaleEisenPerDossier.prioritairGebruikTopsportfederaties.length > 1}
						plusButtonEnabled={minimaleEisenPerDossier.prioritairGebruikTopsportfederaties.length == (i + 1)}
						onMinButtonClick={onTopsportfederatieRemove(i)}
						onPlusButtonClick={onTopsportfederatieAdd}
						disabled={disabled}
					/>
				</Row>
			);
		});
	}

	const dossierType = minimaleEisenPerDossier.typeDossier;
	const isNietTopsport = dossierType == domainConstants.DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_RENOVATIE;
	const deadlineString = moment(minimaleEisenPerDossier.uitersteIndiendatum).format("DD/MM/YYYY");

	return (
		<Section title="Vul het antwoord op onderstaande vragen in" color={color}>
			<Form
				title='Invulformulier minimale eisen "Algemeen"'
				name="minimaleeisen"
				rightButtonLabel="Bewaar"
				onRightButtonClick={onSave}
				rightButtonDisabled={disabled}
				tooltip={TITEL_TOOLTIP}
				tooltipWindowWidth={35}>
				<Fieldset
					title={"Zijn de sportinfrastructuurwerken gestart vóór " + deadlineString + "?"}>
					<RadioButtonGroup
						name="werkenTijdigGestart"
						value={minimaleEisenPerDossier.werkenTijdigGestart}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						validationMessage={errors ? errors.werkenTijdigGestart : ''}
						validationMessageType={validationMessageType} />
					{minimaleEisenPerDossier.werkenTijdigGestart == true || minimaleEisenPerDossier.werkenTijdigGestart === "true" ?
						<TextAreaInput
							name="welkeWerkenGestart"
							label="Licht grondig toe welke werken al gestart zijn"
							value={minimaleEisenPerDossier.welkeWerkenGestart}
							onChange={onChange}
							height={5}
							disabled={disabled}
							tooltip={WELKEWERKENGESTART_TOOLTIP}
							validationMessage={errors ? errors.welkeWerkenGestart : ''}
							validationMessageType={validationMessageType}
							maxLength={2000} />
						: null}
				</Fieldset>
				{isNietTopsport ?
					<Fieldset
						title={"Is de sportinfrastructuur gelegen in het Brussels Hoofdstedelijk Gewest?"}>
						<RadioButtonGroup
							name="gelegenInBrusselsHoofdstedelijkGewest"
							value={minimaleEisenPerDossier.gelegenInBrusselsHoofdstedelijkGewest}
							onChange={onChange}
							disabled={disabled}
							items={jaNee}
							horizontal
							validationMessage={errors ? errors.gelegenInBrusselsHoofdstedelijkGewest : ''}
							validationMessageType={validationMessageType} />
					</Fieldset> : null}
				{minimaleEisenPerDossier.gelegenInBrusselsHoofdstedelijkGewest == true || minimaleEisenPerDossier.gelegenInBrusselsHoofdstedelijkGewest === "true" ?
					<Fieldset
						title={"Wordt de sportinfrastructuur prioritair opengesteld voor Vlaamse erkende sportorganisaties?"}>
						<RadioButtonGroup
							name="prioritairVoorVlaamseErkendeSportorganisaties"
							value={minimaleEisenPerDossier.prioritairVoorVlaamseErkendeSportorganisaties}
							onChange={onChange}
							disabled={disabled}
							items={jaNee}
							horizontal
							validationMessage={errors ? errors.prioritairVoorVlaamseErkendeSportorganisaties : ''}
							validationMessageType={validationMessageType} />
						{minimaleEisenPerDossier.prioritairVoorVlaamseErkendeSportorganisaties == true || minimaleEisenPerDossier.prioritairVoorVlaamseErkendeSportorganisaties === "true" ?
							<TextAreaInput
								name="toelichtingPrioritairVlaamseSportOrganisaties"
								label="Licht toe"
								value={minimaleEisenPerDossier.toelichtingPrioritairVlaamseSportOrganisaties}
								onChange={onChange}
								height={5}
								disabled={disabled}
								validationMessage={errors ? errors.toelichtingPrioritairVlaamseSportOrganisaties : ''}
								validationMessageType={validationMessageType}
								maxLength={1000} />
							: null}
					</Fieldset> : null}
				{isNietTopsport ?
					<Fieldset
						title="Wordt de sportinfrastructuur opengesteld voor het breed publiek?"
						tooltip={OPENGESTELDBREEDPUBLIEK_TOOLTIP}
						tooltipWindowWidth={35}>
						<RadioButtonGroup
							name="opengesteldVoorBreedPubliek"
							value={minimaleEisenPerDossier.opengesteldVoorBreedPubliek}
							onChange={onChange}
							disabled={disabled}
							items={jaNee}
							horizontal
							validationMessage={errors ? errors.opengesteldVoorBreedPubliek : ''}
							validationMessageType={validationMessageType} />
					</Fieldset>
					: ""}
				{isNietTopsport ?
					<Fieldset
						title="Zijn de tarieven van de sportinfrastructuur marktconform?"
						tooltip={MARKTCONFORM_TOOLTIP}
						tooltipWindowWidth={35}>
						<RadioButtonGroup
							name="infrastructuurMarktconform"
							value={minimaleEisenPerDossier.infrastructuurMarktconform}
							onChange={onChange}
							disabled={disabled}
							items={jaNee}
							locked={hasFilesForDossierComponent(domainConstants.ComponentName.RetributieReglement)}
							horizontal
							validationMessage={errors ? errors.infrastructuurMarktconform : ''}
							validationMessageType={validationMessageType} />
						{minimaleEisenPerDossier.infrastructuurMarktconform == true || minimaleEisenPerDossier.infrastructuurMarktconform === "true" ?
							<DownloadUploadFile
								dossierId={minimaleEisenPerDossier.dossierId}
								title="Retributiereglement/tarievenlijst van alle sportinfrastructuren"
								center
								disabled={disabled}
								color={color}
								tab={domainConstants.DocumentTab.MinimaleEisen}
								component={domainConstants.ComponentName.RetributieReglement}
								onDelete={mapDeleteFile(domainConstants.ComponentName.RetributieReglement)}
								onDrop={mapDropFiles(domainConstants.ComponentName.RetributieReglement)}
								files={getFilesForDossierComponent(domainConstants.ComponentName.RetributieReglement)}
								fileTypes={fileTypes.RetributieReglement}
								validationMessage={errors ? errors.ulRetributieReglement : ''}
								validationMessageType={validationMessageType}
								fileSessionStarted={fileSessionStarted} />

							: null}
					</Fieldset>
					: ""}
				{(!isNietTopsport) ?
					<div>
						<Fieldset
							title="Wordt de sportinfrastructuur prioritair opengesteld voor Vlaamse topsportfederaties die participeren in een olympisch of paralympisch ontwikkelingsprogramma en/of prestatieprogramma?">
							<Row>
								<RadioButtonGroup
									name="prioritairVoorVlaamseTopsportfederaties"
									value={minimaleEisenPerDossier.prioritairVoorVlaamseTopsportfederaties}
									onChange={onChange}
									disabled={disabled}
									items={jaNee}
									horizontal
									validationMessage={errors ? errors.prioritairVoorVlaamseTopsportfederaties : ''}
									validationMessageType={validationMessageType} />
							</Row>
						</Fieldset>
						{minimaleEisenPerDossier.prioritairVoorVlaamseTopsportfederaties && minimaleEisenPerDossier.prioritairVoorVlaamseTopsportfederaties.toString() === "true" ?
							<Fieldset title="Priortair gebruik"
								tooltip="Een prioritaire terbeschikkingstelling voor Topsport dient gegarandeerd te worden voor een contingent van minimaal 100 gebruiksuren over een kalenderjaar. Deze prioritaire terbeschikkingstelling wordt vastgelegd in een engagementsverklaring Topsport tussen aanvrager en de betrokken Vlaamse topsportfederatie(s). De Vlaamse topsportfederatie dient op het moment van de subsidieaanvraag te participeren in een Olympisch of Paralympisch talentdetectie-, ontwikkelings- en/of prestatieprogramma."
								tooltipWindowWidth={40}
								tooltipWindowAlignRight
							>
								{selectedTopSportFederaties}
							</Fieldset>
							:
							null}
					</div> : ""}
			</Form>
		</Section>
	);
};

// ----------------------------------------------------------------------------
MinimaleEisenPerDossierForm.propTypes = {
	minimaleEisenPerDossier: PropTypes.object,
	documenten: PropTypes.array.isRequired,
	sjablonen: PropTypes.array.isRequired,
	fileTypes: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	onDropFiles: PropTypes.func.isRequired,
	onDeleteFile: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	deadlinesStartWerken: PropTypes.array.isRequired,
	onTopsportfederatieRemove: PropTypes.func.isRequired,
	onTopsportfederatieAdd: PropTypes.func.isRequired,
	onTopsportfederatieChange: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	fileSessionStarted: PropTypes.bool,
	validationMessageType: PropTypes.string
};

export default MinimaleEisenPerDossierForm;
